import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IProjectStatsFiltersBl } from '../../ProjectStatsFilters.bl';
import { IProjectStatsFiltersStore, IWorker } from '../../ProjectStatsFilters.store';
import { WorkerSelector } from './WorkerSelector';

export const WorkerSelectorContainer = observer((): ReactElement => {
  const bl = useInjection(IProjectStatsFiltersBl.$);
  const store = useInjection(IProjectStatsFiltersStore.$);

  const handleWorkersChange = (workers: IWorker[]): void => {
    bl.hideWorkers(workers);
  };

  return (
    <WorkerSelector
      availableWorkers={store.availableWorkers}
      selectedWorkers={store.visibleWorkers}
      onWorkersChange={handleWorkersChange}
    />
  );
});
